import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';

const {
  GET_DAILY_NOTES_PRINT_STATUS_REQUEST,
  GET_DAILY_NOTES_PRINT_STATUS_SUCCESS,
  GET_DAILY_NOTES_PRINT_STATUS_FAILURE,
  GET_DAILY_NOTES_PRINT_STATUS_LOADING,
} = dailySessionNotes;

function* getPrintStatus(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DAILY_NOTES_PRINT_STATUS_LOADING });

    const response = yield call(dailySessionNotesService.getPrintStatus, action?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_DAILY_NOTES_PRINT_STATUS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DAILY_NOTES_PRINT_STATUS_FAILURE, payload: error });
  }
}

function* getPrintStatusSaga() {
  yield takeLatest(GET_DAILY_NOTES_PRINT_STATUS_REQUEST, getPrintStatus);
}

export default getPrintStatusSaga;
